import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-main-wrapper',
    imports: [CommonModule],
    templateUrl: './main-wrapper.component.html',
    styleUrl: './main-wrapper.component.scss'
})
export class MainWrapperComponent {
    @Input() title = '';
}

